// extracted by mini-css-extract-plugin
module.exports = {"CommentGroup":"CommentGroup_CommentGroup__AjxCg"};